//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import Commons from '../../../../Services/Common/Common';
import { useDispatch } from 'react-redux';
import {
  setSearchText,
  setStartDate,
  setEndDate,
  setGubun,
  setDepCd,
} from '../../../../Reducer/SearchReducer';
import { BuildSamBasic02DepComboItems } from '../SAM_BASIC_02/SAM_BASIC_02';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
import SAM_BASIC_1F from '../SAM_BASIC_01/SAM_BASIC_01F';
import SAM_BASIC_2F from '../SAM_BASIC_02/SAM_BASIC_02F';
// import SAM_BASIC_3F from '../SAM_BASIC_03/SAM_BASIC_03F';
//#endregion

/** 안전작업 허가서 탭 — 처리상태 검색 콤보 (GetSamBasic02R4 Status) */
const WorkPermitStatusFilterComboItems = [
  { value: '', name: '전체' },
  ...[
    '결재요청',
    '결재완료',
    '결재대기',
    '대기',
    '반려',
    '승인요청',
    '승인',
    '만료',
    '연장요청',
    '연장대기',
    '연장반려',
    '입회요청',
    '입회중',
    '입회완료',
    '작업완료',
  ].map((name) => ({ value: name, name })),
];

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ width: '100%', height: '100%', minHeight: 0 }}>
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function SAM_BASIC(props) {
  const dispatch = useDispatch();
  const searchRef = React.useRef({});

  // searchInfo가 변경될 때 searchRef 업데이트
  React.useEffect(() => {
    if (props.searchInfo) {
      if (props.searchInfo) {
        searchRef.current = {
          custCd: props.searchInfo.custCd || '',
          depCd: props.searchInfo.depCd || '',
          startDate: props.searchInfo.startDate || '',
          endDate: props.searchInfo.endDate || '',
          gubun: props.searchInfo.gubun || '',
          searchText: props.searchInfo.searchText || '',
        };
      }
    }
  }, [props.searchInfo]);

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="SafetyWorkManagement"
          // placeholder={'파일명'}
          searchYn="Y"
          addYn="Y"
          saveYn={props.value === 1 ? 'N' : 'Y'}
          deleteYn={props.value === 1 ? 'N' : 'Y'}
          printYn={props.value === 1 ? 'Y' : 'N'}
          multiPrintYn={props.value === 1 ? 'N' : 'Y'}
          fileValidFc={() => {
            if (!props.validateSelection()) {
              return false; // 실패
            }
            return true; // 성공
          }}
          printItem={
            props.value === 0
              ? props.printItem1
              : props.value === 1
                ? props.printItem2
                : props.value === 2
                  ? props.printItem3
                  : props.value === 3
                    ? props.printItem4
                    : ''
          }
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            dispatch(setSearchText(e));
            if (props.value === 0) {
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              props.setFilterClick2(true);
            } else if (props.value === 2) {
              props.setFilterClick3(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            }
          }}
          deleteClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setDeleteClick1(true);
            } else if (props.value === 1) {
              props.setDeleteClick2(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            }
          }}
          conditions={[
            {
              type: 'datePicker',
              title:
                props.lanInfo.length === 0
                  ? ''
                  : props.lanInfo.find(
                      (f) => f.lanType !== 'MENU' && f.lanId === 'Period'
                    ).LAN_NM, //기간
              name: Commons.IsMobile()
                ? props.searchInfo.startDate
                : '조회일자(시작)',
              value: dayjs(props.searchInfo.startDate),
              onChange: (date) => {
                const newStartDate = dayjs(date).format('YYYY-MM-DD');
                let updatedEnd =
                  props.searchInfo.endDate ||
                  (props.value === 1
                    ? dayjs().add(1, 'month').format('YYYY-MM-DD')
                    : dayjs().format('YYYY-MM-DD'));

                if (!dayjs(newStartDate).isBefore(dayjs(updatedEnd))) {
                  updatedEnd = newStartDate;
                }

                // ref는 useEffect보다 늦게 맞춰지면 자식 조회 context가 이전 일자를 씀 → onChange에서 즉시 동기화
                searchRef.current = {
                  custCd: props.searchInfo?.custCd || '',
                  depCd: props.searchInfo?.depCd || '',
                  startDate: newStartDate,
                  endDate: updatedEnd,
                  gubun: props.searchInfo?.gubun || '',
                  searchText: props.searchInfo?.searchText || '',
                };

                dispatch(setStartDate(newStartDate));
                dispatch(setEndDate(updatedEnd));

                if (props.value === 0) {
                  props.setSearchClick1(true);
                } else if (props.value === 1) {
                  props.setSearchClick2(true);
                } else if (props.value === 2) {
                  props.setSearchClick3(true);
                }
              },
              currentLocale: 'ko',
            },
            {
              type: 'datePicker',
              title:
                props.lanInfo.length === 0
                  ? ''
                  : props.lanInfo.find(
                      (f) => f.lanType !== 'MENU' && f.lanId === 'Period'
                    ).LAN_NM, //기간
              name: Commons.IsMobile()
                ? props.searchInfo.endDate
                : '조회일자(끝)', //기간
              value: dayjs(props.searchInfo.endDate),
              onChange: (date) => {
                const newEndDate = dayjs(date).format('YYYY-MM-DD');
                let updatedStart =
                  props.searchInfo.startDate ||
                  (props.value === 1
                    ? dayjs().subtract(1, 'month').format('YYYY-MM-DD')
                    : dayjs().subtract(3, 'year').format('YYYY-MM-DD'));

                if (dayjs(newEndDate).isBefore(dayjs(updatedStart))) {
                  updatedStart = newEndDate;
                }

                searchRef.current = {
                  custCd: props.searchInfo?.custCd || '',
                  depCd: props.searchInfo?.depCd || '',
                  startDate: updatedStart,
                  endDate: newEndDate,
                  gubun: props.searchInfo?.gubun || '',
                  searchText: props.searchInfo?.searchText || '',
                };

                dispatch(setStartDate(updatedStart));
                dispatch(setEndDate(newEndDate));

                if (props.value === 0) {
                  props.setSearchClick1(true);
                } else if (props.value === 1) {
                  props.setSearchClick2(true);
                } else if (props.value === 2) {
                  props.setSearchClick3(true);
                }
              },
              currentLocale: 'ko',
            },
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: props.searchInfo.coList,
                    value: props.searchInfo.coCd,
                    onChange: async (e) => {
                      await props.handleCoChange(e);

                      if (props.value === 1) {
                        dispatch(setDepCd(''));
                        searchRef.current = {
                          ...searchRef.current,
                          depCd: '',
                        };
                      }

                      if (props.value === 0) {
                        await props.setSearchClick1(true);
                      } else if (props.value === 1) {
                        await props.setSearchClick2(true);
                      } else if (props.value === 2) {
                        await props.setSearchClick3(true);
                      }
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: props.searchInfo.custList,
              value: props.searchInfo.custCd,
              onChange: async (e) => {
                await props.handleCustChange(e);

                if (props.value === 1) {
                  dispatch(setDepCd(''));
                  searchRef.current = {
                    ...searchRef.current,
                    depCd: '',
                  };
                }

                if (props.value === 0) {
                  await props.setSearchClick1(true);
                } else if (props.value === 1) {
                  await props.setSearchClick2(true);
                } else if (props.value === 2) {
                  await props.setSearchClick3(true);
                }
              },
            },
            {
              type: 'combo',
              name: '부서',
              items:
                props.value === 1
                  ? BuildSamBasic02DepComboItems(props.searchInfo.depList || [])
                  : props.searchInfo.depList || [],
              value: props.searchInfo.depCd ?? '',
              onChange: async (e) => {
                await props.handleDepChange(e);

                if (props.value === 0) {
                  await props.setSearchClick1(true);
                } else if (props.value === 1) {
                  await props.setSearchClick2(true);
                } else if (props.value === 2) {
                  await props.setSearchClick3(true);
                }
              },
            },
            ...(props.value === 1
              ? [
                  {
                    type: 'combo',
                    name: '처리상태',
                    items: WorkPermitStatusFilterComboItems,
                    value: props.searchInfo.gubun || '',
                    onChange: (e) => {
                      dispatch(setGubun(e));
                      props.setSearchClick2(true);
                    },
                  },
                ]
              : []),
          ]}
          grids={
            <React.Fragment>
              <Box sx={{ mb: 1 }}>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="작업계획서"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="안전작업 허가서"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <SAM_BASIC_1F
                  searchInfo={props.searchInfo}
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  copyClick1={props.copyClick1}
                  setCopyClick1={props.setCopyClick1}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <SAM_BASIC_2F
                  searchInfo={props.searchInfo}
                  searchRef={searchRef}
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  copyClick2={props.copyClick2}
                  setCopyClick2={props.setCopyClick2}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>

              <CustomTabPanel value={props.value} index={3}></CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default SAM_BASIC;
